import { render } from "./MellonWebECRIntentResultLabel.vue?vue&type=template&id=c354c4b4"
import script from "./MellonWebECRIntentResultLabel.vue?vue&type=script&lang=js"
export * from "./MellonWebECRIntentResultLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__